function AboutSection({ title, subtitle, description, description2, contactButton, contactPhone, contactLine, contactKakao }) {
  return (
    <section className="py-10 sm:py-[60px] bg-dark">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#fdb06c' }}>{subtitle}</p>
        <h2 className="font-playfair text-4xl sm:text-5xl font-bold mb-8" style={{ color: '#e48e41' }}>{title}</h2>
        <div className="section-divider mb-12 max-w-xs mx-auto" />
        <p className="font-montserrat text-xl sm:text-2xl text-white/70 leading-relaxed mb-8">{description}</p>
        <p className="font-montserrat text-lg sm:text-xl text-white/50 leading-relaxed italic">{description2}</p>

        {contactButton && (
          <div className="mt-12">
            <a
              href="https://line.me/ti/p/z2MKz54daM"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block font-montserrat text-sm tracking-widest uppercase bg-gold text-dark px-12 py-5 hover:bg-gold-light transition-all duration-300 glow-gold"
            >
              {contactButton}
            </a>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-10 mt-10">
              <a href="https://wa.me/66811103766" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-white/60 hover:text-gold transition-colors">
                <img src="/icon-whatsapp.png" alt="WhatsApp" className="w-6 h-6 object-contain" />
                <span className="font-montserrat text-sm">{contactKakao}</span>
              </a>
              <a href="https://line.me/ti/p/z2MKz54daM" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-white/60 hover:text-gold transition-colors">
                <img src="/icon-line.png" alt="LINE" className="w-6 h-6 object-contain" />
                <span className="font-montserrat text-sm">{contactLine}</span>
              </a>
              <a href="tel:081-110-3766" className="flex items-center space-x-3 text-white/60 hover:text-gold transition-colors">
                <svg className="w-6 h-6 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="font-montserrat text-sm">{contactPhone}</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default AboutSection;
